module.exports = __webpack_public_path__ + "img/button_Save.32637231.svg";